
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-slate-800 grid-pattern dark">
      <div className="max-w-md mx-auto text-center px-4">
        <div className="mb-6 flex justify-center">
          <div className="bg-red-500/20 p-3 rounded-full">
            <FaExclamationTriangle className="h-12 w-12 text-red-500" />
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-4">404: Page Not Found</h1>
        <p className="text-xl text-gray-400 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-x-4">
          <Button asChild variant="default" className="bg-truth hover:bg-truth-dark">
            <Link to="/">Return to Home</Link>
          </Button>
          <Button asChild variant="outline">
            <a href="mailto:support@truthnexus.com">Report Issue</a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
